/** Direct coding sessions on a task, the dispatch dialog and its runs. */
export default {
  directSession: "Direct session",
  statusStarting: "Starting",
  statusRunning: "Turn running",
  statusWaitingApproval: "Waiting approval",
  statusIdle: "Idle",
  statusFailed: "Failed",
  statusClosed: "Closed",
  statusInApp: "{status}, in your app",
  actionFailed: "That did not work. Try again.",
  openAppFailed: "Could not open the app: {reason}",
  open: "Open",
  mayBeWaiting: "May be waiting for your approval",
  toRunTool: "To run {tool}. Answer it in the app.",
  answerInApp: "Answer it in the app.",
  asksForApproval: "The chat asks for approval",
  allow: "Allow",
  deny: "Deny",
  messagePlaceholder: "Send a message to the chat",
  messageLabel: "Message to the chat",
  send: "Send",
  stop: "Stop",
  chatBusy: "That chat is busy in your app.",
  sendWhenFinished: "Send when it finishes",
  messageQueued: "A message is queued",
  goesWhenFinished: "It goes when the turn finishes",
  dispatchTitle: "Start a direct chat",
  dispatchIntro:
    "Denker opens this in your own coding tool, in the folder you pick. It only sends turns you ask for.",
  readingCheckout: "Reading checkout…",
  companionOffline: "Companion not connected — checkout unknown.",
  checkoutBranch: "branch {branch}",
  checkoutDetached: "detached at {head}",
  unknown: "unknown",
  thisMac: "This Mac",
  checkoutLine: "{device}: {head} · {count} uncommitted",
  titlePlaceholder: "What should it work on?",
  goalPlaceholder: "Goal (optional)",
  codingTool: "Coding tool",
  folder: "Folder",
  anotherFolder: "Another folder…",
  folderPathPlaceholder: "Folder path, like /Users/you/code/app",
  mac: "Mac",
  chooseMac: "Choose which Mac starts this chat.",
  dispatchFailed: "Could not dispatch that chat. Try again.",
  starting: "Starting…",
  startChat: "Start chat",
  runs: "Runs",
  runsFailed: "Runs couldn't load.",
  runRunning: "Running",
  runFinished: "Finished",
  runFailed: "Failed",
  runStopped: "Stopped",
  runDuration: "{minutes} min",
  runDurationSoFar: "{minutes} min so far",
  runWaits: "Waits for you to check the result.",
  acceptResult: "Accept result",
  notDone: "Not done",
  reviewSaveFailed: "The outcome review could not be saved.",
} as const;
